import React from 'react'
import {Box, Container, Grid} from "@mui/material";
import useWindowDimensions from "../../utils/Helpers";

const cities = require("../../data/cities.json")
const DiagramLayout= (props:any) =>{
    const {language, isPrinting } = props
    const input = JSON.parse(localStorage.getItem("tum_leitfaden_input") as string) as any
    const {height, width} = useWindowDimensions();
    const city = cities[language].find((city: any) => city.id === Number(input.city_id))
    const getImagePath = (cityName:string, period:string) =>{
        if(cityName && period){
            try {
                if(period === "2003") {
                    return require("../../assets/cities/"+ language + "/2003/" + city.img)
                }
                else if(period === "RCP 2.6 (2081-2090)"){
                    return require("../../assets/cities/"+ language + "/rcp26/" + city.img)
                }
                else if(period === "RCP 8.5 (2081-2090)"){
                    return require("../../assets/cities/"+ language + "/rcp85/" + city.img)
                }
                else{
                    return require("../../assets/cities/"+ language + "/1991-2020/" + city.img)
                }
            } catch (error) {
                console.warn(`Image not found for city ${city?.name} (${city?.img}) in period ${period}`);
                // Return null or a placeholder image path
                return null;
            }
        }
        return null;
    }

    return(
        <Container>
            <Box sx={{maxWidth: width * 0.8, maxHeight:750}}>
                <Grid item xs={12} style={{textAlign: "center", padding: 4, margin: 8}}>
                    {getImagePath(city.img,input.period) ? (
                        <Box
                            component="img"
                            sx={{
                                height: isPrinting ? 250:   height / 2.5 ,
                                width: isPrinting ?  350:  width / 3.75 ,
                            }}
                            alt="City"
                            src={getImagePath(city.img,input.period)}
                        />
                    ) : (
                        <Box sx={{
                            height: isPrinting ? 250:   height / 2.5 ,
                            width: isPrinting ?  350:  width / 3.75 ,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            border: '1px dashed #ccc'
                        }}>
                            Image not available
                        </Box>
                    )}
                </Grid>
            </Box>
        </Container>
    )
}
export default DiagramLayout
